// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Configuracion.module.css */

.Configuracion_page__lA89w {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Configuracion_intro__1qkbz {
  margin-bottom: 4px;
}

.Configuracion_pageTitle__z5Fsx {
  font-size: 20px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 4px;
}

.Configuracion_pageDesc__2f9zu {
  font-size: 14px;
  color: #667085;
}

/* Card */
.Configuracion_card__S\\+tYX {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e4e7ec;
  overflow: hidden;
}

.Configuracion_cardHeader__Z\\+HMW {
  padding: 16px 24px 12px;
  border-bottom: 1px solid #f2f4f7;
  display: flex;
  align-items: center;
  gap: 10px;
}

.Configuracion_categoryBadge__afWvd {
  display: none;
}

.Configuracion_cardTitle__IrXNk {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0;
}

/* Filas */
.Configuracion_settingsList__yiW8y {
  padding: 0 24px;
}

.Configuracion_settingRow__IVdWk {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 0;
  border-bottom: 1px solid #f2f4f7;
}

.Configuracion_settingRow__IVdWk:last-child {
  border-bottom: none;
}

.Configuracion_settingInfo__dHbcV {
  flex: 1 1;
}

.Configuracion_settingLabel__luWiE {
  font-size: 14px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 2px;
}

.Configuracion_settingDesc__9hRFF {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 4px;
  line-height: 1.5;
}

.Configuracion_settingKey__n5Baq {
  font-size: 11px;
  color: #b0b8c9;
  background: #f9fafb;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #eaecf0;
}

/* Control */
.Configuracion_settingControl__ggg6u {
  flex-shrink: 0;
  min-width: 220px;
}

.Configuracion_valueGroup__b3hZO {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}

.Configuracion_value__ob-rF {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  transition: color 0.3s;
}

.Configuracion_valueSaved__hQdC- {
  color: #2db899;
}

.Configuracion_savedBadge__ZxVcj {
  font-size: 11px;
  color: #2db899;
  font-weight: 600;
}

/* Edit mode */
.Configuracion_editGroup__nfqPg {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
}

.Configuracion_input__uWf2Y {
  width: 160px;
  padding: 8px 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  outline: none;
  transition: border-color 0.15s;
}

.Configuracion_input__uWf2Y:focus {
  border-color: #1a3a5c;
}

.Configuracion_inputError__xSCQ6 {
  border-color: #f04438;
}

.Configuracion_inputErrorMsg__qGeoI {
  font-size: 11px;
  color: #f04438;
}

.Configuracion_editActions__Z9Zj0 {
  display: flex;
  gap: 6px;
}

/* Botones */
.Configuracion_btnEdit__qH71s {
  padding: 6px 14px;
  border-radius: 7px;
  border: 1.5px solid #e4e7ec;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  cursor: pointer;
  transition: all 0.15s;
}

.Configuracion_btnEdit__qH71s:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

.Configuracion_btnSave__buYDB {
  padding: 7px 16px;
  border-radius: 7px;
  border: none;
  background: #1a3a5c;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.Configuracion_btnSave__buYDB:hover:not(:disabled) {
  background: #2db899;
}

.Configuracion_btnSave__buYDB:disabled {
  background: #98a2b3;
  cursor: not-allowed;
}

.Configuracion_btnCancel__Ywt8\\+ {
  padding: 7px 14px;
  border-radius: 7px;
  border: 1.5px solid #e4e7ec;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
}

.Configuracion_btnCancel__Ywt8\\+:hover:not(:disabled) {
  border-color: #f04438;
  color: #f04438;
}

/* Estados */
.Configuracion_loading__RmPJY {
  padding: 40px;
  text-align: center;
  color: #667085;
  font-size: 14px;
}

.Configuracion_errorGlobal__OGwB5 {
  padding: 20px 24px;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 10px;
  color: #b42318;
  font-size: 14px;
}

@media (max-width: 600px) {
  .Configuracion_settingRow__IVdWk {
    flex-direction: column;
    gap: 10px;
  }

  .Configuracion_settingControl__ggg6u {
    min-width: unset;
    width: 100%;
  }

  .Configuracion_valueGroup__b3hZO {
    justify-content: flex-start;
  }

  .Configuracion_editGroup__nfqPg {
    align-items: flex-start;
    width: 100%;
  }

  .Configuracion_input__uWf2Y {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PanelAdmin/Configuracion.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Configuracion.module.css */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.intro {\n  margin-bottom: 4px;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 4px;\n}\n\n.pageDesc {\n  font-size: 14px;\n  color: #667085;\n}\n\n/* Card */\n.card {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e4e7ec;\n  overflow: hidden;\n}\n\n.cardHeader {\n  padding: 16px 24px 12px;\n  border-bottom: 1px solid #f2f4f7;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.categoryBadge {\n  display: none;\n}\n\n.cardTitle {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0;\n}\n\n/* Filas */\n.settingsList {\n  padding: 0 24px;\n}\n\n.settingRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 18px 0;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.settingRow:last-child {\n  border-bottom: none;\n}\n\n.settingInfo {\n  flex: 1;\n}\n\n.settingLabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: #344054;\n  margin-bottom: 2px;\n}\n\n.settingDesc {\n  font-size: 12px;\n  color: #98a2b3;\n  margin-bottom: 4px;\n  line-height: 1.5;\n}\n\n.settingKey {\n  font-size: 11px;\n  color: #b0b8c9;\n  background: #f9fafb;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #eaecf0;\n}\n\n/* Control */\n.settingControl {\n  flex-shrink: 0;\n  min-width: 220px;\n}\n\n.valueGroup {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  transition: color 0.3s;\n}\n\n.valueSaved {\n  color: #2db899;\n}\n\n.savedBadge {\n  font-size: 11px;\n  color: #2db899;\n  font-weight: 600;\n}\n\n/* Edit mode */\n.editGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n}\n\n.input {\n  width: 160px;\n  padding: 8px 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.inputError {\n  border-color: #f04438;\n}\n\n.inputErrorMsg {\n  font-size: 11px;\n  color: #f04438;\n}\n\n.editActions {\n  display: flex;\n  gap: 6px;\n}\n\n/* Botones */\n.btnEdit {\n  padding: 6px 14px;\n  border-radius: 7px;\n  border: 1.5px solid #e4e7ec;\n  background: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  color: #344054;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btnEdit:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n.btnSave {\n  padding: 7px 16px;\n  border-radius: 7px;\n  border: none;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.btnSave:hover:not(:disabled) {\n  background: #2db899;\n}\n\n.btnSave:disabled {\n  background: #98a2b3;\n  cursor: not-allowed;\n}\n\n.btnCancel {\n  padding: 7px 14px;\n  border-radius: 7px;\n  border: 1.5px solid #e4e7ec;\n  background: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  color: #667085;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btnCancel:hover:not(:disabled) {\n  border-color: #f04438;\n  color: #f04438;\n}\n\n/* Estados */\n.loading {\n  padding: 40px;\n  text-align: center;\n  color: #667085;\n  font-size: 14px;\n}\n\n.errorGlobal {\n  padding: 20px 24px;\n  background: #fef3f2;\n  border: 1px solid #fecdca;\n  border-radius: 10px;\n  color: #b42318;\n  font-size: 14px;\n}\n\n@media (max-width: 600px) {\n  .settingRow {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .settingControl {\n    min-width: unset;\n    width: 100%;\n  }\n\n  .valueGroup {\n    justify-content: flex-start;\n  }\n\n  .editGroup {\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .input {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Configuracion_page__lA89w`,
	"intro": `Configuracion_intro__1qkbz`,
	"pageTitle": `Configuracion_pageTitle__z5Fsx`,
	"pageDesc": `Configuracion_pageDesc__2f9zu`,
	"card": `Configuracion_card__S+tYX`,
	"cardHeader": `Configuracion_cardHeader__Z+HMW`,
	"categoryBadge": `Configuracion_categoryBadge__afWvd`,
	"cardTitle": `Configuracion_cardTitle__IrXNk`,
	"settingsList": `Configuracion_settingsList__yiW8y`,
	"settingRow": `Configuracion_settingRow__IVdWk`,
	"settingInfo": `Configuracion_settingInfo__dHbcV`,
	"settingLabel": `Configuracion_settingLabel__luWiE`,
	"settingDesc": `Configuracion_settingDesc__9hRFF`,
	"settingKey": `Configuracion_settingKey__n5Baq`,
	"settingControl": `Configuracion_settingControl__ggg6u`,
	"valueGroup": `Configuracion_valueGroup__b3hZO`,
	"value": `Configuracion_value__ob-rF`,
	"valueSaved": `Configuracion_valueSaved__hQdC-`,
	"savedBadge": `Configuracion_savedBadge__ZxVcj`,
	"editGroup": `Configuracion_editGroup__nfqPg`,
	"input": `Configuracion_input__uWf2Y`,
	"inputError": `Configuracion_inputError__xSCQ6`,
	"inputErrorMsg": `Configuracion_inputErrorMsg__qGeoI`,
	"editActions": `Configuracion_editActions__Z9Zj0`,
	"btnEdit": `Configuracion_btnEdit__qH71s`,
	"btnSave": `Configuracion_btnSave__buYDB`,
	"btnCancel": `Configuracion_btnCancel__Ywt8+`,
	"loading": `Configuracion_loading__RmPJY`,
	"errorGlobal": `Configuracion_errorGlobal__OGwB5`
};
export default ___CSS_LOADER_EXPORT___;
